export const BANNER_EVENT = 'show-banner';
export const SHOW_MARKER_IO_REPORTED = 'marker-io-report-menu';
export const CHANGE_LANGUAGE = 'change-app-language';
export const SHOW_SLOW_LOADING_POPUP = 'show-slow-loading-popup';
export const LOG_SENTRY_ERROR = 'log-sentry-error';
export const RESET_IMPORTED_HOURS = 'reset-imported-hours';
